<script lang="ts">
  import ForecastContainer from "./ForecastContainer.svelte";
  import {  Condition, conditions, cType, ForecastType, Observation } from "../store";
  import TemperatureCondition from "./conditions/TemperatureCondition.svelte";
  import WbgtCondition from "./conditions/WBGTCondition.svelte";
  import WindCondition from "./conditions/WindCondition.svelte";
  import PrecipitationCondition from "./conditions/PrecipitationCondition.svelte";
  import GustCondition from "./conditions/GustCondition.svelte";
  import FeelsLikeCondition from "./conditions/FeelsLikeCondition.svelte";
  import AqiCondition from "./conditions/AqiCondition.svelte";
  import { getPollutantTypeFromCondition } from "../aqiHelpers";

  export let conditionOnWidget: Array<Condition> = [];
  export let forecasts: Array<{id:string, forecastType: ForecastType; conditionType: cType }> = [];

  const lightningConditions = [cType.LR1, cType.LR_C2G]; // widget-api stores the lightning trigger as a condition row; it has no Current Conditions component
  const filteredConditions = conditionOnWidget.filter(c => !lightningConditions.includes(c.conditionType));
  let totalSections = (filteredConditions.length > 0 ? 1 : 0) + forecasts.length;
  const conditionComponents = [ TemperatureCondition, WbgtCondition, WindCondition, PrecipitationCondition, GustCondition, FeelsLikeCondition, AqiCondition, AqiCondition, AqiCondition ];
  const conditionTypes = [ "Temperature", "WBGT", "Wind Speed", "Precipitation", "Wind Gust", "Feels Like", "PM2.5", "PM10", "Ozone", "AQI" ];

  let currentConditions: Observation;
  conditions.subscribe((value) => {
    if(value) currentConditions = value;
  });
</script>

{#if totalSections > 0}
  <div class="pw-container pw-footer"  data-iframe-height >
    <div class="pw-flex" style="flex-wrap: wrap;">
      {#if conditionOnWidget.length > 0 && currentConditions}
        <div
          class="pw-column-{Math.floor(100 / totalSections)} pw-footer-column pw-flex-column pw-align-center"
        >
        <div class="label">Current Conditions</div>
        <div class="pw-flex" style="width: 100%; height: 100%">
              {#each filteredConditions as cond}
                <div 
                class="pw-flex pw-justify-center pw-column-{Math.floor(100 / filteredConditions.length)} cc-{cond.toString().toLowerCase()}"
                >
                {#if [6,7,8,9].includes(cond.conditionType)}
                  <AqiCondition pollutantType={getPollutantTypeFromCondition(cond.conditionType)} />
                {:else}
                  <svelte:component this={conditionComponents[cond.conditionType]}   />
                {/if}
                </div>
              {/each}
            </div>
        </div>
      {/if}

      {#each forecasts as forecast}
        <div
          class="pw-column-{Math.floor(100 / totalSections)} pw-footer-column pw-flex-column pw-align-center"
        >
          {#if forecast.forecastType == 0}  
            <div class="label">Hourly {conditionTypes[forecast.conditionType]}</div>
          {/if}
          {#if forecast.forecastType == 1}
            <div class="label">Daily {conditionTypes[forecast.conditionType]}</div>
          {/if}
          <ForecastContainer
            forecastType={forecast.forecastType}
            conditionType={forecast.conditionType}
          />
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .pw-footer {
    width: 100%;
    border: 1px solid #35404F;
    
    margin-bottom: 20px;
    border-radius: 1rem;
    z-index: 0;
    padding: 1rem;
  }
  .pw-footer-column .row {
    flex-direction: row;
  }
  .pw-footer-column:not(:last-child) {
    border-right: 1px solid #35404F;
  }
  .pw-column-25{
    width: 25%;
  }
  .pw-column-33{
    width: 33%;
  }
  .pw-column-50{
    width: 50%;
  }
  .pw-column-100{
    width: 100%;
  }
  .pw-footer .container {
    padding: 0 0.5rem;
  }
  @media (max-width: 399px) {
    .pw-footer-column {
      width: 100%;
      max-width: 100% !important;
      border-right: none !important;
    }
    .pw-footer-column:not(:first-child) {
      border-top: 1px solid #35404F;
      margin-top: 1rem;
    }
  }
</style>
